<script setup lang="ts">
import { useTemplateRef } from 'vue'

import { useSortable } from '@vueuse/integrations/useSortable'

type Props = {
  disabled?: boolean
}
const props = defineProps<Props>()

// data
const animation = 200

// refs
const el = useTemplateRef<HTMLDivElement>('el')

// model
const list = defineModel<unknown[]>({ required: true })

// composables
useSortable(el, list, {
  handle: '.drag-handle',
  animation,
  dragoverBubble: true,
  disabled: props.disabled,
})
</script>

<template>
  <div ref="el">
    <slot />
  </div>
</template>
